import { render, staticRenderFns } from "./SettingExactDetail.vue?vue&type=template&id=97cbce34&scoped=true"
import script from "./SettingExactDetail.vue?vue&type=script&lang=js"
export * from "./SettingExactDetail.vue?vue&type=script&lang=js"
import style0 from "./SettingExactDetail.vue?vue&type=style&index=0&id=97cbce34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cbce34",
  null
  
)

export default component.exports